<template>
  <div class="w-100 d-flex flex-column align-start">
    <div class="d-flex justify-end align-center w-100" style="gap: 15px">
      <div v-if="receiptCompletionDate">
        <span class="font-weight-medium"> Data de Finalização:</span> {{ receiptCompletionDate }}
      </div>
      <div><span class="font-weight-medium"> CTE:</span> {{ receiptCte }}</div>
      <div><span class="font-weight-medium"> NFE:</span> {{ receiptNfe }}</div>
      <div class="mr-1">
        <span @click="handleIsExpanded">
          <v-icon size="30" :class="isExpandedClass" :color="isExpandedIconColor">mdi-chevron-up</v-icon>
        </span>
      </div>
    </div>
    <v-expand-transition>
      <div v-show="isExpanded" class="w-100">
        <div class="ml-9">
          <v-divider class="mb-1" />
          <v-row dense class="ma-0 pa-0">
            <v-col cols="12" class="details-header d-flex">Remetente</v-col>
            <v-col cols="12" class="d-flex"
              ><span class="font-weight-medium">Nome:&nbsp;</span> {{ receipt.senderName }}
            </v-col>
            <v-col cols="12" class="d-flex"
              ><span class="font-weight-medium">CNPJ/CPF:&nbsp;</span> {{ receipt.cpfOrCnpjSender }}
            </v-col>
            <v-col cols="12" class="details-header d-flex">Destinatário</v-col>
            <v-col cols="12" class="d-flex"
              ><span class="font-weight-medium">Nome:&nbsp;</span> {{ receipt.recipientName }}
            </v-col>
            <v-col cols="12" class="d-flex"
              ><span class="font-weight-medium">CNPJ/CPF:&nbsp;</span> {{ receipt.cpfOrCnpjRecipient }}
            </v-col>
            <v-col v-if="receipt.validatorName" cols="12">
              <v-row dense class="ma-0 pa-0">
                <v-col cols="12" class="details-header d-flex">Aprovado por</v-col>
                <v-col cols="12" class="d-flex"
                  ><span class="font-weight-medium">Nome:&nbsp;</span> {{ receipt.validatorName }}
                </v-col>
                <v-col cols="12" class="d-flex"
                  ><span class="font-weight-medium">CNPJ/CPF:&nbsp;</span> {{ receipt.cpfOrCnpjValidator }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-expand-transition>
    <div class="d-flex align-center w-100">
      <v-checkbox
        :disabled="isDisabled"
        hide-details
        :input-value="isReceiptSelected"
        :v-model="receiptId"
        @click="onClickSelectReceipt"
      />

      <div :class="`pa-1 w-100 d-flex rounded mx-1 ${validatedReceiptClass}`" style="position: relative">
        <img
          v-if="hasImage"
          @click="onClickSelectReceipt"
          :src="receiptImage"
          :alt="receiptName"
          class="rounded w-100 cursor-pointer"
        />
        <div
          v-else-if="printMode"
          @click="onClickSelectReceipt"
          class="w-100 d-flex justify-center align-center rounded cursor-pointer"
          style="background-color: #e7e7e7; max-height: 258px; min-height: 150px"
        >
          <div class="d-flex flex-column">
            <v-icon class="" large color="#717171"> mdi-image-remove </v-icon>
            <h3 class="font-weight-medium" style="color: #717171">Não possui canhoto</h3>
          </div>
        </div>
        <div
          v-else
          class="w-100 d-flex justify-center align-center rounded"
          style="background-color: #e7e7e7; max-height: 258px; min-height: 150px"
        >
          <div class="d-flex flex-column">
            <v-icon class="" large color="#717171"> mdi-image-remove </v-icon>
            <h3 class="font-weight-medium" style="color: #717171">Não possui canhoto</h3>
          </div>
        </div>

        <div v-if="isValidated" class="validated-flag">
          <v-chip class="ma-2" color="success" label text-color="white">
            <v-icon left> mdi-check </v-icon>
            Canhoto aprovado {{ getApproveUserName(receipt.validatorName) }}
          </v-chip>
        </div>
      </div>

      <template v-if="printMode">
        <div class="d-flex flex-column align-self-stretch">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="onRemoveFromPrintClick"
                v-on="on"
                v-bind="attrs"
                color="red"
                dark
                depressed
                class="flex-grow-1 pa-0 ma-1"
                style="min-width: 34px"
              >
                <v-icon size="20">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Remover</span>
          </v-tooltip>
        </div>
      </template>

      <template v-else>
        <div v-if="hasImage" class="d-flex flex-column align-self-stretch">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="onApproveClick"
                :disabled="isValidated"
                v-on="on"
                v-bind="attrs"
                color="green"
                :dark="!isValidated"
                depressed
                class="flex-grow-1 pa-0 ma-1"
                style="min-width: 34px"
              >
                <v-icon size="20">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>Aprovar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="onDeleteClick"
                v-on="on"
                v-bind="attrs"
                color="red"
                dark
                depressed
                class="flex-grow-1 pa-0 ma-1"
                style="min-width: 34px"
              >
                <v-icon size="20">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Deletar</span>
          </v-tooltip>
        </div>
        <div v-else class="d-flex flex-column align-self-stretch">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="onUploadReceiptClick"
                v-on="on"
                v-bind="attrs"
                color="info"
                depressed
                class="flex-grow-1 pa-0 ma-1"
                style="min-width: 34px"
              >
                <v-icon size="20"> mdi-upload</v-icon>
              </v-btn>
            </template>
            <span> Anexar canhoto</span>
          </v-tooltip>
          <input ref="uploader" class="d-none" type="file" @change="onFileChanged($event)" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ReceiptsManagementHandler } from '@/store/modules/receiptsManagement';

export default {
  props: {
    receipt: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    isSelected: false,
    isExpanded: false
  }),

  computed: {
    isReceiptSelected() {
      return ReceiptsManagementHandler.getSelectedReceipt(this, this.receiptId);
    },

    isDisabled() {
      if (this.printMode) return false;

      const { receipt } = this;
      if (receipt) {
        return receipt.srcImage === null;
      }
      return false;
    },

    isValidated() {
      const { receipt } = this;
      if (receipt) {
        return receipt.isValidated;
      }
      return false;
    },

    receiptId() {
      const { receipt } = this;
      if (receipt) {
        return receipt.id;
      }
      return null;
    },

    receiptNfeId() {
      const { receipt } = this;
      if (receipt) {
        return receipt.nfeId;
      }
      return null;
    },

    receiptCte() {
      const { receipt } = this;
      if (receipt) {
        return receipt.numberCte;
      }
      return null;
    },

    receiptNfe() {
      const { receipt } = this;
      if (receipt) {
        return receipt.numberNfe;
      }
      return null;
    },

    receiptImage() {
      const { receipt } = this;
      if (receipt) {
        return receipt.srcImage;
      }
      return null;
    },

    receiptName() {
      const { receipt } = this;
      if (receipt) {
        return receipt.name;
      }
      return null;
    },

    receiptCompletionDate() {
      const { receipt } = this;
      return receipt.completionDate ? this.formatDate(receipt.completionDate) : null;
    },

    hasImage() {
      const { srcImage: image } = this.receipt;
      return image !== null;
    },

    validatedReceiptClass() {
      return this.isReceiptSelected ? 'validated-receipt' : '';
    },

    isExpandedClass() {
      return `${this.isExpanded ? '' : 'expanded-section'} mr-1 cursor-pointer`;
    },

    isExpandedIconColor() {
      return this.isExpanded ? 'primary' : '';
    },

    printMode() {
      return ReceiptsManagementHandler.getPrintMode(this);
    }
  },
  methods: {
    onClickSelectReceipt() {
      const { id } = this.receipt;
      ReceiptsManagementHandler.setSelectedReceipts(this, id);
    },

    onApproveClick() {
      this.$emit('approveReceipt', this.receiptId);
    },

    onDeleteClick() {
      this.$emit('deleteReceipt', this.receiptId);
    },

    onRemoveFromPrintClick() {
      this.$emit('removeFromPrint', this.receiptNfeId);
    },

    onUploadReceiptClick() {
      window.addEventListener('focus', () => {}, { once: true });
      this.$refs.uploader.click();
    },

    onFileChanged(e) {
      const [file] = e.target.files;
      const { nfeId } = this.receipt;
      this.$emit('receiptAppend', { file, nfeId });
      this.$refs.uploader.value = null;
    },

    handleIsExpanded() {
      this.isExpanded = !this.isExpanded;
    },

    formatDate(d) {
      if (d === null) return d;
      let dateObj = new Date(`${d}`);
      return dateObj.toLocaleDateString('pt-BR');
    },

    getApproveUserName(name) {
      return name ? `por ${name.split(' ')[0]}` : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper-to-print {
  display: none;
}
.validated-receipt {
  background: hsla(210, 79%, 46%, 0.65);
}
.validated-flag {
  position: absolute;
  bottom: 3px;
}
.approve-remove-btn {
  position: absolute;
  top: 10px;
  left: 10px;
}

.details-header {
  background: rgb(228, 228, 228);
}
.selected-column {
  background: #2c8ef0 !important;
}
.v-input--selection-controls {
  margin-top: 0px !important;
}
</style>
